import * as React from "react"

import { useTranslations } from "@/i18n"

import type { AccountingLabels } from "@/features/reports/services/adapters/accounting-adapters"

/**
 * The accounting enum → label resolver every accounting adapter needs. Lives in one place because both the
 * on-screen report (useReportData) and the CSV export (useReportExport) adapt the same payloads: if they
 * translated enums differently, the file would not match the screen.
 */
export function useAccountingLabels(): AccountingLabels {
  const t = useTranslations("finance.accounting")
  return React.useMemo<AccountingLabels>(
    () => ({
      type: (value) => t(`types.${value}`),
      classification: (value) => t(`classifications.${value}`),
      direction: (value) => t(`directions.${value}`),
      entryStatus: (value) => t(`entryStatus.${value}`),
      source: (value) => t(`sourceTypes.${value}`),
    }),
    [t],
  )
}
